import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  @Input() open = false;
  @Output() close = new EventEmitter<void>();

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }


  languages = [
    { code: 'hr', flag: 'assets/lang/hr.png', labelKey: 'LANG.HR' },
    { code: 'en', flag: 'assets/lang/en.png', labelKey: 'LANG.EN' },
    { code: 'it', flag: 'assets/lang/it.png', labelKey: 'LANG.IT' },
    { code: 'de', flag: 'assets/lang/de.png', labelKey: 'LANG.DE' }
  ];

  audioModes = [
    {
      id: 'all',
      icon: 'assets/icons/all.png',
      titleKey: 'SIDEBAR.AUDIO_MODES.ALL_TITLE',
      descKey: 'SIDEBAR.AUDIO_MODES.ALL_DESC'
    },
    {
      id: 'normal',
      icon: 'assets/icons/normal.png',
      titleKey: 'SIDEBAR.AUDIO_MODES.NORMAL_TITLE',
      descKey: 'SIDEBAR.AUDIO_MODES.NORMAL_DESC'
    },
    {
      id: 'archaeology',
      icon: 'assets/icons/archaeology.png',
      titleKey: 'SIDEBAR.AUDIO_MODES.ARCH_TITLE',
      descKey: 'SIDEBAR.AUDIO_MODES.ARCH_DESC'
    }
  ];

  selectedLanguage = 'hr';
  selectedAudioMode = 'all';

  ngOnInit() {
    this.selectedLanguage =
      localStorage.getItem('language') || 'hr';

    this.selectedAudioMode =
      localStorage.getItem('audioMode') || 'all';
  }

  selectLanguage(lang: string): void {
    this.selectedLanguage = lang;
    localStorage.setItem('language', lang);
    this.translate.use(lang);
    this.cdr.detectChanges();
  }


  selectAudioMode(id: string) {
    this.selectedAudioMode = id;
    localStorage.setItem('audioMode', id);
  }
}
